module.exports = __webpack_public_path__ + "static/media/MOF_hero.2561c7a6.jpg";